import React from 'react';
import styled from 'styled-components';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import FunnelUpdatePane from '../../../containers/funnel/update/Pane';
import FunnelUpdateStepContainer from '../../../containers/funnel/update/StepContainer';
import FunnelUpdateStep from '../../../containers/funnel/update/Step';
import FunnelUpdateStepFilter from '../../../containers/funnel/update/StepFilter';
import FunnelUpdateHeader from './Header';

const StyledFunnelUpdatePaneContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  border: 1px solid #999999;
  margin: 1px 1px 10px;
  background-color: #fff;
`;

const UpdateStep = ({ renderUpdateStepProps }) => {
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: renderUpdateStepProps.id,
  });

  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <StyledFunnelUpdatePaneContainer ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <FunnelUpdateStep
        {...renderUpdateStepProps}
        renderStepFilter={(renderStepFilterProps) => (
          <FunnelUpdateStepFilter {...renderStepFilterProps} />
        )}
      />
    </StyledFunnelUpdatePaneContainer>
  );
};

const FunnelUpdatePaneContainer = (props) => (
  <FunnelUpdatePane {...props}>
    <FunnelUpdateHeader />
    <FunnelUpdateStepContainer
      renderUpdateStep={(renderUpdateStepProps) => (
        <UpdateStep renderUpdateStepProps={renderUpdateStepProps} />
      )}
    />
  </FunnelUpdatePane>
);

export default FunnelUpdatePaneContainer;
